<template>
    <div v-if="error" class="layout-default bg-gray-900 flex flex-col justify-between">
        <app-header />

        <div class="abstract-gradients w-full h-screen fixed overflow-hidden bg-transparent top-0 pointer-events-none">
            <div class="abstract-gradients-top w-full h-full absolute overflow-hidden bg-transparent top-0">
                <div class="circle"></div>
                <div class="rectangle"></div>
            </div>
        </div>

        <component :is="component" class="mt-[72px]" />

        <app-footer />
    </div>
</template>

<script setup lang="ts">
import type { NuxtError } from "nuxt/app";
// * interface
interface Props {
    error: NuxtError;
}

// * props
const props = defineProps<Props>();

// * computed properties
const component = computed(() => {
    switch (props.error.statusCode) {
        case 404:
            return defineAsyncComponent(() => import("~/components/errors/Error404.vue"));
        case 500:
            return defineAsyncComponent(() => import("~/components/errors/Error500.vue"));
        default:
            return defineAsyncComponent(() => import("~/components/errors/Error500.vue"));
    }
});
</script>

<style lang="scss">
@keyframes rotate {
    0% {
        transform: rotate(-10deg);
    }
    50% {
        transform: rotate(-250deg);
    }
    100% {
        transform: rotate(-10deg);
    }
}

@keyframes move {
    0% {
        transform: translateX(0px);
    }
    50% {
        transform: translateX(400px);
    }
    100% {
        transform: translateX(0px);
    }
}

.layout-default {
    & .abstract-gradients {
        &-top {
            > .circle {
                top: -8%;
                left: 50%;
                z-index: 0;
                opacity: 0.5;
                width: 472.01px;
                height: 669.67px;
                position: absolute;
                filter: blur(119.798px);
                transform: rotate(-90.11deg);
                animation: rotate, move 7s ease-in-out infinite;
                background: linear-gradient(180deg, rgba(24, 75, 255, 0) 0%, #174aff 100%);
            }
            > .rectangle {
                top: -30%;
                left: 10%;
                z-index: 0;
                opacity: 0.3;
                width: 982.35px;
                height: 982.35px;
                position: absolute;
                border-radius: 99999px;
                filter: blur(119.798px);
                transform: rotate(-90.11deg);
                animation: move, rotate 7s ease-in-out infinite;
                background: linear-gradient(180deg, rgba(0, 194, 255, 0.5) 0%, #ff29c3 100%);
            }
        }
    }
}
</style>
